module.exports = "https://images.shiksha.ws/saassets/media/location_icon.8b986966.svg";